import React from "react";
import styled from "styled-components";
import { ISunset } from "../../../../../pages/Manage/Sunset/Sunset";
import SunsetSubs from "./SunsetSubs";
import SunriseSubs from "./SunriseSubs";
import SunsetParty from "./SunsetParty";
import SunsetType from "./SunsetType";
import NotifyType from "./NotifyType";
import SunsetDate from "./SunsetDate";
import NotifyDate from "./NotifyDate";
import SunsetReason from "./SunsetReason";
import SunriseDate from "./SunriseDate";

export interface ISunsetData {
  state: {
    sunsetData: ISunset;
  };
}

export default function SunsetDetailInfo() {
  return (
    <VerticalTable>
      {/* 일몰 대상 서비스 */}
      <SunsetSubs />

      {/* 신규 전환 서비스 */}
      <SunriseSubs />

      {/* 적용 대상 파티, PID 입력 */}
      <SunsetParty />

      {/* 일몰 실행일 */}
      <SunsetDate />

      {/* 정책 변경일 */}
      <SunriseDate />

      {/* 일몰 타입 */}
      <SunsetType />

      {/* 일몰 통지일 */}
      <NotifyDate />

      {/* 통지 횟수 */}
      <NotifyType />

      {/* 일몰 템플릿 */}
      <SunsetReason />
    </VerticalTable>
  );
}

const VerticalTable = styled.div``;
